import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserHelper } from '../helpers/user.helper';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private userHelper: UserHelper, private router: Router) {}

  canActivate(): boolean {
    if (this.userHelper.isAuthenticated()) {
      return true;
    } else {
      // Redirect to login page or another unauthorized page
      this.router.navigate(['/auth/login-page']);
      return false;
    }
  }
}